import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/** One Account & Card Opening Pipeline row (TSYS stages) — PRD §3.6/§1.9. */
export interface CardOfferPipelineRow {
  smeId: string;
  smeName: string | null;
  cui: string | null;
  creditLimitEur: number;
  pipelineStage: string;
  offerStatus: string;
  offerBadge: string;
}

/** The calling E-D's card-offers view (PRD §3.6). */
export interface CardOffersView {
  pipeline: CardOfferPipelineRow[];
  pendingCount: number;
  acceptedCount: number;
  rejectedCount: number;
}

/**
 * DI token for the E-D Card Offers API (PRD §3.6/§1.9, EM-836). Bound to `EdCardOffersRestService`.
 * E-D-scoped server-side (Rule 22). REST-only (Rules 07/10).
 */
export interface EdCardOffersApi {
  /** GET /services/embedded/api/v1/ed/card-offers */
  getCardOffers(): Observable<CardOffersView>;
}

export const ED_CARD_OFFERS = new InjectionToken<EdCardOffersApi>('ED_CARD_OFFERS');
